import _ from "lodash";
import api from "./api";

const findFilter = (filterName, filters) =>
  _.find(filters, (x) => x.filterName === filterName);

const filterHelpers = {
  // gets a new filters array based on the new filter
  // being sent back to the page from the filter component
  getFilters(priorFilters, newFilter) {
    const filterIndex = _.findIndex(priorFilters, x => x.filterName === newFilter.filterName);
    let newFilters = _.slice(priorFilters);
    if (filterIndex === -1) {
      newFilters.push(newFilter);
    } else {
      newFilters[filterIndex] = newFilter;
    }
    newFilters = _.reject(newFilters, (x) => x.label === "Any");
    return newFilters.filter((x) =>
      x.value !== null ||
      (x.values && x.values.length && x.values.length > 0) ||
      x.startDate ||
      x.endDate
    );
  },

  getValue(filters, name) {
    const filterElement = _.find(filters, (f) => f.filterName === name);
    if (filterElement) {
      if (_.has(filterElement, 'selectValue')) {
        return filterElement.selectValue
      }
      if (_.has(filterElement, 'value')) {       
        return filterElement.value;
      }
      return filterElement.values;
    }
    return "";
  },

  isStartBeforeEnd(filters) {
    const startDate = findFilter("startDate", filters);
    const endDate = findFilter("endDate", filters);
    if (!startDate || !endDate) return false;
    return startDate.value <= endDate.value;
  },

  saveSearch(area, sortDir, sortField, filters) {
    api
      .post("saveSearch", {
        area,
        serializedSearch: {
          sortField,
          sortDir,
          filters,
        },
      })
      .catch((error) => error);
  },

  setSavedFilters(area, callBack) {
    api
      .fetch("getSavedSearch", { area })
      .then((response) => {
        const search = response.data.serializedSearch;
        callBack(search.sortField, search.sortDir, search.filters);
      })
      .catch((error) => error);
  },

  transformFilters(filters = []) {
    return filters.reduce((acc, item, i) => {
      let itemValueToAdd;
      if (item.value === null || item.value === undefined) {
        //allow false to be passed
        if (item.values) {
          itemValueToAdd = item.values;
        }
      } else if(item.filterName === "itemNumber") {
        itemValueToAdd = item.value.itemNumber
      } else {
        itemValueToAdd = item.value;
      }
      //acc[item.filterName] = item.value || item.values;
      acc[item.filterName] = itemValueToAdd;
      return acc;
    }, {});
  },

  transformFiltersMultiToCSV(filters = []) {
    return filters.reduce((acc, item, i) => {
      acc[item.filterName] = item.value ? item.value : item.values.join(",");
      return acc;
    }, {});
  }
}

export default filterHelpers;
